<div class="modal-header">
  <h4 class="modal-title platformModal__title">
    @if (platform) {
      Editar plataforma {{ platform.sku }}
    }

    @if (!platform) {
      Nueva plataforma
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body platformModal">
  @if (!loading) {
    <form
      id="formPlatform"
      [formGroup]="formPlatform"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid px-0">
        <div class="row">

          <!-- Datos derivados: van como texto de solo lectura FUERA de los
               inputs, nunca precargados dentro de un campo editable. -->
          @if (platform) {
            <div class="col-12 mb-4">
              <div class="platformModal__meta">

                <p class="platformModal__metaRow d-flex mb-1">
                  <span class="platformModal__metaLabel">ID</span>
                  <span class="platformModal__metaValue text-truncate">
                    {{ platform.platformId }}
                  </span>
                </p>

                <p class="platformModal__metaRow d-flex mb-1">
                  <span class="platformModal__metaLabel">Alta</span>
                  <span class="platformModal__metaValue text-truncate">
                    {{ platform.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </span>
                </p>

                <p class="platformModal__metaRow d-flex mb-0">
                  <span class="platformModal__metaLabel">Actualizada</span>
                  <span class="platformModal__metaValue text-truncate">
                    {{ platform.updatedAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </span>
                </p>

              </div>
            </div>
          }

          @for (key of utilService.objectKeys(dataForm); track key) {
            <div class="col-12 form-group mb-4">
              <label [htmlFor]="key" class="form-label">
                {{ dataForm[key].label }}
              </label>
              <input
                [id]="key"
                [type]="dataForm[key].type"
                class="form-control"
                formControlName="{{ key }}"
                [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                [attr.aria-invalid]="submitted && f[key].errors ? 'true' : null"
                [attr.aria-describedby]="submitted && f[key].errors ? key + 'Error' : null"
                [ngClass]="{
                  'is-invalid': submitted && f[key].errors
                }">
                @if (submitted && f[key].errors && dataForm[key].required) {
                  <div class="invalid-feedback" [id]="key + 'Error'">
                    @if (f[key].errors!['required']) {
                      <div>{{ dataForm[key].requiredMessage }}</div>
                    }
                  </div>
                }
            </div>
          }

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100 platformModal__actionBtn">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <!-- Nunca deshabilitado: la validación se resuelve en onSubmit(). -->
    <button
      type="submit"
      form="formPlatform"
      class="btn btn-primary w-100 platformModal__actionBtn">
      {{ platform ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
